export type RuleCond = { field: string; op: string; value?: any }
export type RuleGroup = { all?: RuleNode[]; any?: RuleNode[] }
export type RuleNode = RuleCond | RuleGroup

export const isGroup = (n: RuleNode): n is RuleGroup => !!(n as any).all || !!(n as any).any

export function createEmptyGroup(mode: "all" | "any" = "all"): RuleGroup {
  return mode === "all" ? { all: [] } : { any: [] }
}

export function createEmptyCond(): RuleCond {
  return { field: "", op: "", value: "" }
}
